import {
  SectionElement,
  defineElement,
  on,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/sections/bb-text-icons/bb-text-icons.ts
var BbTextIcons = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.cards = [];
    this.dots = [];
    this.frame = 0;
  }
  connectedCallback() {
    var _a;
    this.cards = (_a = this.cardElements) != null ? _a : [];
    if (!this.track || this.cards.length === 0)
      return;
    this.resizeObserver = new ResizeObserver(() => {
      this.measure();
    });
    this.resizeObserver.observe(this.track);
  }
  disconnectedCallback() {
    var _a;
    (_a = this.resizeObserver) == null ? void 0 : _a.disconnect();
    this.resizeObserver = void 0;
    cancelAnimationFrame(this.frame);
  }
  onScroll() {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => {
      this.update();
    });
  }
  prev() {
    if (this.metrics)
      this.goTo(this.currentIndex(this.metrics) - 1);
  }
  next() {
    if (this.metrics)
      this.goTo(this.currentIndex(this.metrics) + 1);
  }
  selectDot(_, event) {
    const dot = event.target.closest("[data-index]");
    if (dot)
      this.goTo(Number(dot.dataset.index));
  }
  selectBlock(_, event) {
    const index = this.cards.indexOf(event.target);
    if (index > -1 && this.metrics)
      this.goTo(Math.floor(index / this.metrics.perGroup));
  }
  measure() {
    const track = this.track;
    const firstCard = this.cards[0];
    if (!track || !firstCard)
      return;
    const style = getComputedStyle(track);
    const gap = parseFloat(style.columnGap) || 0;
    const padLeft = parseFloat(style.paddingLeft) || 0;
    const padRight = parseFloat(style.paddingRight) || 0;
    const cardWidth = firstCard.getBoundingClientRect().width;
    const step = cardWidth + gap;
    if (step <= 0)
      return;
    const clientWidth = track.clientWidth;
    const fullyVisible = Math.floor((clientWidth - padLeft - padRight + gap) / step + 0.01);
    const perGroup = Math.max(1, fullyVisible);
    const positions = Math.ceil(this.cards.length / perGroup);
    this.metrics = { cardWidth, step, padLeft, padRight, clientWidth, maxScroll: track.scrollWidth - clientWidth, perGroup, positions };
    this.classList.toggle("is-static", this.cards.length <= fullyVisible);
    if (this.dots.length !== positions)
      this.buildDots(positions);
    this.update();
  }
  update() {
    const track = this.track;
    const m = this.metrics;
    if (!track || !m)
      return;
    const scrollLeft = track.scrollLeft;
    const index = this.currentIndex(m);
    this.dots.forEach((dot, i) => {
      dot.setAttribute("aria-current", String(i === index));
    });
    if (this.prevButton)
      this.prevButton.disabled = scrollLeft <= 2;
    if (this.nextButton)
      this.nextButton.disabled = scrollLeft >= m.maxScroll - 2;
    const viewLeft = scrollLeft + m.padLeft;
    const viewRight = scrollLeft + m.clientWidth - m.padRight + 1;
    this.cards.forEach((card, i) => {
      const cardLeft = m.padLeft + i * m.step;
      const visiblePart = Math.min(cardLeft + m.cardWidth, viewRight) - Math.max(cardLeft, viewLeft);
      card.classList.toggle("is-out", visiblePart / m.cardWidth < 0.6);
    });
  }
  currentIndex(m) {
    var _a, _b;
    const scrollLeft = (_b = (_a = this.track) == null ? void 0 : _a.scrollLeft) != null ? _b : 0;
    if (m.maxScroll > 0 && scrollLeft >= m.maxScroll - 2)
      return m.positions - 1;
    const index = Math.round(scrollLeft / (m.step * m.perGroup));
    return Math.max(0, Math.min(m.positions - 1, index));
  }
  goTo(index) {
    const m = this.metrics;
    if (!this.track || !m)
      return;
    const position = Math.max(0, Math.min(m.positions - 1, index));
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    this.track.scrollTo({ left: position * m.step * m.perGroup, behavior: reduceMotion ? "auto" : "smooth" });
  }
  buildDots(positions) {
    if (!this.dotsWrap)
      return;
    this.dots = Array.from({ length: positions }, (_, i) => {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "bb-ic__dot";
      dot.dataset.index = String(i);
      if (this.track != null)
        dot.setAttribute("aria-controls", this.track.id);
      dot.setAttribute("aria-label", `Position ${i + 1} von ${positions}`);
      return dot;
    });
    this.dotsWrap.replaceChildren(...this.dots);
  }
};
__decorateClass([
  query("[data-bb-track]")
], BbTextIcons.prototype, "track", 2);
__decorateClass([
  queryAll("[data-bb-card]")
], BbTextIcons.prototype, "cardElements", 2);
__decorateClass([
  query("[data-bb-prev]")
], BbTextIcons.prototype, "prevButton", 2);
__decorateClass([
  query("[data-bb-next]")
], BbTextIcons.prototype, "nextButton", 2);
__decorateClass([
  query("[data-bb-dots]")
], BbTextIcons.prototype, "dotsWrap", 2);
__decorateClass([
  on("scroll", "[data-bb-track]")
], BbTextIcons.prototype, "onScroll", 1);
__decorateClass([
  onClick("[data-bb-prev]")
], BbTextIcons.prototype, "prev", 1);
__decorateClass([
  onClick("[data-bb-next]")
], BbTextIcons.prototype, "next", 1);
__decorateClass([
  onClick("[data-bb-dots]")
], BbTextIcons.prototype, "selectDot", 1);
__decorateClass([
  on("shopify:block:select")
], BbTextIcons.prototype, "selectBlock", 1);
BbTextIcons = __decorateClass([
  defineElement("bb-text-icons")
], BbTextIcons);
export {
  BbTextIcons
};
